import { render, staticRenderFns } from "./my-reservations.vue?vue&type=template&id=16875a5b&"
import script from "./my-reservations.vue?vue&type=script&lang=ts&"
export * from "./my-reservations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports